import api from '@/api/ks/relation.js'
const state = {
}
const mutations = {
}
const actions = {
	relationList({}, params = {}) {
        return api.relationList(params)
    },
    relationAdd({}, params = {}) {
        return api.relationAdd(params)
    },
    authorCourseIndex({}, params = {}) {
        return api.authorCourseIndex(params)
    },
    authorShowIndex({}, params = {}) {
        return api.authorShowIndex(params)
    },
    relationRemove({}, params = {}) {
        return api.relationRemove(params)
    }
}
export default {
	namespaced:true,
	state,
	mutations,
	actions,
}